export const playPlatformSound = (filename: string) => {
  try {
    const audio = new Audio("/" + filename);
    audio.play();
  } catch (error) {
    console.log("Play sound.", error);
  }
};
